import React from 'react';

interface PaginationProps {
	currentPage: number;
	totalPages: number;
	 
	onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
	const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

	return (
		<div className="flex justify-center items-center space-x-1">
			{/* Previous Button */}
			<button
				className={`px-3 py-2 text-sm font-medium transition-all duration-200 rounded-md ${currentPage === 1
					? 'text-gray-400 cursor-not-allowed'
					: 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
					}`}
				onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
				disabled={currentPage === 1}
			>
				←
			</button>

			{/* Page Buttons */}
			<div className="flex space-x-1 mx-2">
				{pages.map((page) => (
					<button
						key={page}
						className={`w-10 h-10 text-sm font-medium transition-all duration-200 rounded-md ${page === currentPage
							? 'bg-gray-950 text-white shadow-sm'
							: 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
							}`}
						onClick={() => onPageChange(page)}
					>
						{page}
					</button>
				))}
			</div>

			{/* Next Button */}
			<button
				className={`px-3 py-2 text-sm font-medium transition-all duration-200 rounded-md ${currentPage === totalPages
					? 'text-gray-400 cursor-not-allowed'
					: 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
					}`}
				onClick={() => currentPage < totalPages && onPageChange(currentPage + 1)}
				disabled={currentPage === totalPages}
			>
				→
			</button>
		</div>
	);
};

export default Pagination;
